import { withStyles } from "@material-ui/core/styles";
import SrButton from "../SrButton";

const SrFilterButton = withStyles((theme) => ({
  root: {
    fontWeight: "normal",
    marginRight: theme.spacing(1),
    whiteSpace: "nowrap",
    fontSize: theme.typography.pxToRem(15),
  },
  iconSizeMedium: {
    "& > *:first-child": {
      fontSize: theme.typography.pxToRem(24),
    },
  },
}))(SrButton);

export default SrFilterButton;
